import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReportContentListComponent } from './report-content-list/report-content-list.component';
import { ReportContentDetailsComponent } from './report-content-details/report-content-details.component';

const routes: Routes = [
  {
    path: '',
    component: ReportContentListComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportContentsRoutingModule {}
